export default "__VITE_ASSET__CTfY00dh__"